import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function CostCenter(props) {
    const { t } = useTranslation("translation");

    return props.isNotMultipleCostCenter ? (
        <Autocomplete
            id="bl_table_Autocomplete_6"
            onChange={(_event, newValue) => {
                props.HandleCostCenterChange(newValue);
            }}
            value={props.costCenterData.filter((item) => props.selectedCostCenterId === item.id)[0]?.name}
            options={props.costCenterData.map((option) => option.name)}
            renderInput={(params) => <TextField id="bl_table_TextField_5" {...params} margin="normal" label={t("CostCenter")} variant="outlined" />}
            size={props.size ?? "normal"}
        />
    ) : (
        <Autocomplete
            multiple
            id="bl_table_Autocomplete_6"
            options={props.costCenterData}
            limitTags={5}
            value={props.costCenterData.filter((item) => props.selectedCostCenterId?.includes(item.id))}
            disableCloseOnSelect
            getOptionLabel={(option) => option.name}
            renderInput={(params) => <TextField id="bl_table_TextField_5" {...params} margin="normal" label={t("CostCenter")} variant="outlined" />}
            onChange={(_event, newValue) => {
                props.HandleCostCenterChange(newValue);
            }}
            renderOption={(_props, option) => <li {..._props}>{option.name}</li>}
            size={props.size ?? "normal"}
        />
    );
}
